export default __webpack_public_path__ + "static/media/tally.657b2b30.png";